import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    sex: Yup.string().nullable().required('Pole wymagane'),
    isPregnantOrBreastfeeding: Yup.string()
        .nullable()
        .when('sex', {
            is: (value) => value === 'female',
            then: Yup.string()
                .nullable()
                .required('Pole wymagane')
                .test(
                    'isPregnantOrBreastfeeding',
                    'Wskazana stacjonarna konsultacja z Iekarzem',
                    (value) => value === null || value !== 'yes',
                ),
        }),
    isSubstanceDependentOrUsing: Yup.string()
        .nullable()
        .required('Pole wymagane')
        .test(
            'isSubstanceDependentOrUsing',
            'Wskazana stacjonarna konsultacja z Iekarzem',
            (value) => value === null || value !== 'yes',
        ),
    isAlergicToMedication: Yup.string().nullable().required('Pole wymagane'),
    alergicMedications: Yup.string()
        .nullable()
        .when('isAlergicToMedication', {
            is: (val) => val === 'yes',
            then: Yup.string().nullable().required('Pole wymagane'),
        }),
    isTakingCurrentlyMedications: Yup.string().nullable().required('Pole wymagane'),
    currentlyMedications: Yup.string()
        .nullable()
        .when('isTakingCurrentlyMedications', {
            is: (val) => val === 'yes',
            then: Yup.string().required('Pole wymagane'),
        }),
    hasChronicOrComorbidConditions: Yup.string().nullable().required('Pole wymagane'),
    chronicOrComorbid: Yup.string()
        .nullable()
        .when('hasChronicOrComorbidConditions', {
            is: (val) => val === 'yes',
            then: Yup.string().nullable().required('Pole wymagane'),
        }),
    importantInformation: Yup.string().required('Pole wymagane'),
    marihuanaMedication: Yup.string()
        .nullable()
        .when('isDoctorChoice', {
            is: (val) => !val,
            then: Yup.string().nullable().required('Pole wymagane'),
        }),
    isDoctorChoice: '',
    ...sharedSchema,
});
